import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";

import { openProductModal } from "../../../redux/features/productModalSlice";
import Search from "../../../common/Search";
import {
  ProductList, DeleteProduct, ProductChangeStatus,
} from "../../../redux/services/ProductService/product.Services";
import Swal from "sweetalert2";
import { Pagination } from "react-bootstrap";
import { useSelector } from "react-redux";
function AllProductList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const [limit, setLimit] = useState(100);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const refreshData = useSelector(
    (state) => state.productModal.refreshData
  );
  const fetchProduct = async () => {
    try {
      setLoading(true);

      const payload = {
        page,
        search,
        limit,
        status,
      };

      const res = await ProductList(payload);

      setProduct(res?.data || []);
      setImageUrl(res?.image_url || "");
      setLastPage(res?.last_page || 1);
      setTotalRecords(res?.total || 0);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [page, search, status, refreshData]);
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= lastPage) {
      setPage(newPage);
    }
  };

  // if (loading) return <h4>Loading...</h4>;

  return (
    <div>
      <div className="d-md-flex d-block align-items-center justify-content-between mt-1 page-header-breadcrumb">
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="page-header">
            <div>
              <h3 className="page-title">Product List</h3>
              <nav className="page-breadcrumb">
                <Link to="/">Home</Link>
                <span className="mx-2">/</span>
                <span>All Products </span>
              </nav>
            </div>
          </div>

          <button
            className="add-btn"
            onClick={() =>
              // dispatch(
              //   openProductModal({
              //     type: "create-category",
              //     title: "Create Category",
              //     data: {
              //       refreshData: fetchCategories,
              //     },
              //   }),
              // )
              navigate("/add-product")
            }
          >
            + Add Product
          </button>
        </div>
      </div>
      <div className="main_page">

        {(totalRecords > 0 || search) && (
          <div className="d-flex justify-content-end align-items-center mx-2 mb-2">
            <Search
              search={search}
              placeholder="Search Category..."
              onSearch={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
          </div>
        )}
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr</th>
                  <th>Image</th>
                  <th>Product Name</th>
                  {/* <th>Vendor Name</th> */}
                  {/* <th>sku</th> */}
                  <th>category</th>
                  {/* <th>Subcategory</th> */}
                  <th>brand</th>
                  <th>unit</th>
                  {/* <th>Status</th> */}
                  <th>Change Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {product.length > 0 ? (
                  product.map((item, index) => (
                    <tr key={item.id}>

                      <td>{index + 1 + (page - 1) * limit}</td>

                      <td>
                        <img
                          // src={
                          //   item.images?.[0]?.image_url
                          //     ? `https://crm.a2logicgroup.com/${item.images[0].image_url}`
                          //     : "/assets/images/no-image.png"
                          // }
   src={
      item?.images?.[0]?.image_url
        ? `${process.env.REACT_APP_IMAGE_URL}/${item.images[0].image_url}`
        : "/assets/images/no-image.png"
    }                          alt={item.name || "Product"}
                          width="40"
                          height="30"
                          style={{
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      </td>
                      <td className="text-nowrap">{item.name}</td>
                      {/* <td>{item?.user?.name || '-'}</td> */}
                      <td>{item.category_details?.name || "-"}</td>
                      {/* <td>{item.subcategory_details?.name || "-"}</td> */}
                      <td>{item.brands_details?.name || "-"}</td>
                      <td>{item.units_details?.name || "-"}</td>
                      {/* Status */}
                      {/* <td>{item.status === 1 ? "Active" : "Inactive"}</td> */}

                      {/* Change Status */}
                      <td>
                        <div className="city-status-switch">
                          <input
                            type="checkbox"
                            id={`status-${item.id}`}
                            className="city-status-input"
                            checked={item.status === 1}
                            onChange={() =>
                              dispatch(
                                openProductModal({
                                  type: "change-toggle-status",
                                  title: "Change Status",
                                  data: {
                                    id: item.id,
                                    status:
                                      item.status === 1 ? "Active" : "Inactive",
                                    statusFunction: ProductChangeStatus,
                                    onSuccess: fetchProduct,
                                  },
                                })
                              )
                            }
                          />
                          <label
                            htmlFor={`status-${item.id}`}
                            className="city-status-label"
                          >
                            <span className="city-status-ball"></span>
                            <span className="city-status-text">
                              {item.status === 1 ? "Active" : "Inactive"}
                            </span>
                          </label>
                        </div>
                      </td>
                      {/* Action */}
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center gap-1 flex-nowrap">
                          <button
                            className="st-action-btn st-view-btn"
                            // onClick={() =>
                            //   dispatch(
                            //     openProductModal({
                            //       type: "view-product",
                            //       title: "View Product",
                            //       data: item,
                            //     })
                            //   )
                            // }
                            onClick={() => navigate(`/view-product/${item.id}`)}
                          >
                            <FaEye />
                          </button>

                          <button
                            className="st-action-btn st-edit-btn"
                            // onClick={() =>
                            //   dispatch(
                            //     openProductModal({
                            //       type: "edit-product",
                            //       title: "Edit Product",
                            //       data: {
                            //         ...item,
                            //         refreshData: fetchProduct,
                            //       },
                            //     })
                            //   )
                            // }
                            onClick={() => navigate(`/edit-product/${item.id}`)}
                          >
                            <FaEdit />
                          </button>

                          <button
                            className="st-action-btn st-delete-btn"
                            onClick={() =>
                              dispatch(
                                openProductModal({
                                  type: "delete-product",
                                  title: "Delete Product",
                                  data: {
                                    id: item.id,
                                    deleteFunction: DeleteProduct,
                                    refreshData: fetchProduct,
                                  },
                                })
                              )
                            }
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="text-center">
                      <p className="mb-0">No Data Found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {lastPage > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={lastPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  );
}

export default AllProductList;